import { Link } from "react-router-dom";
import { workSteps } from "@/data/services";
import { cn } from "@/lib/utils";

export interface HowIWorkProps {
  className?: string;
}

/** "Como eu trabalho" da home: os 4 passos comuns às frentes + link para /sobre. */
export function HowIWork({ className }: HowIWorkProps) {
  return (
    <section className={cn("border-y border-border bg-card", className)}>
      <div className="mx-auto max-w-[1180px] px-8 py-[70px] max-[900px]:px-5">
        <h2 className="text-[31px] font-bold tracking-[-0.03em]">Como eu trabalho</h2>
        <p className="mb-8 mt-3 text-[15.5px] text-muted-foreground">
          O mesmo caminho para site, sistema ou automação.{" "}
          <Link to="/sobre" className="font-semibold text-primary hover:text-primary-deep">
            Meus princípios →
          </Link>
        </p>
        <ol className="grid grid-cols-[repeat(auto-fit,minmax(220px,1fr))] gap-[18px]">
          {workSteps.map((s) => (
            <li key={s.n} className="rounded-2xl border border-border bg-background p-6">
              <div className="flex h-8 w-8 items-center justify-center rounded-[10px] bg-accent text-[13px] font-bold text-primary">
                {s.n}
              </div>
              <div className="mt-4 text-[15px] font-bold tracking-[-0.01em]">{s.title}</div>
              <p className="mt-2 text-[13.5px] leading-[1.6] text-muted-foreground">{s.desc}</p>
              <div className="mt-3 text-[11.5px] font-bold text-muted-foreground">{s.when}</div>
            </li>
          ))}
        </ol>
      </div>
    </section>
  );
}

export default HowIWork;
